import { useEffect, useState } from "react";
import StudioIcon from "./Icons/StudioIcon";
import ContactButton from "./ContactButton";

const StudioHero = () => {
  const [startDesignAnimation, setStartDesignAnimation] = useState<boolean>(false);
  const [startBuildAnimation, setStartBuildAnimation] = useState<boolean>(false);
  const [startDelAnimation, setStartDelAnimation] = useState<boolean>(false);
  const [startColorAnimation, setStartColorAnimation] = useState<boolean>(false);

  useEffect(() => {
    const startDesignAnimationTimer = setTimeout(() => {
      setStartDesignAnimation(true);
    }, 50);
    const startBuildAnimationTimer = setTimeout(() => {
      setStartBuildAnimation(true);
    }, 1050);
    const startDelAnimationTimer = setTimeout(() => {
      setStartDelAnimation(true);
    }, 2050);

    const startColorTimer = setTimeout(() => {
      setStartColorAnimation(true);
    }, 2750);

    return () => {
      clearTimeout(startDesignAnimationTimer);
      clearTimeout(startBuildAnimationTimer);
      clearTimeout(startDelAnimationTimer);
      clearTimeout(startColorTimer);
    };
  }, []);
  return (
    <section className="relative flex-1 min-h-[calc(100dvh-78px)] max-h-[calc(100dvh-78px)] bg-black md:px-15 xl:px-30 [grid-template-rows:20%_10%_30%_40%] xl:grid-rows-3 text-white grid grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-12 gap-4 md:gap-6 xl:gap-8 xl:gap-y-0 items-center">
      <h1 className="col-span-full xl:col-span-10 text-xl md:text-3xl lg:text-[50px] 2xl:text-[64px] lg:leading-[1.2] xl:leading-[1.2] font-xExpandedBold px-6 xl:px-0">
        <span
          className={`transition-opacity ease-in duration-1000  ${
            startDesignAnimation ? " opacity-100" : "opacity-0"
          }`}
        >
          DESIGN ,
        </span>{" "}
        <span
          className={`transition-opacity ease-in duration-1000  ${
            startBuildAnimation ? " opacity-100" : "opacity-0"
          } `}
        >
          BUILD ,
        </span>{" "}
        <span
          className={`transition-all ease-liner duration-1000  ${
            startColorAnimation ? "text-cultiv-red" : "text-white"
          }  ${startDelAnimation ? "opacity-100" : "opacity-0"} `}
        >
          DELIVER .
        </span>
      </h1>
      <div className="lg:col-start-3 col-span-full xl:col-span-8 grid grid-cols-4 xl:col-start-5 xl:grid-cols-8 xl:gap-8 row-start-2 w-full self-start logo z-30 relative max-h-min">
        <div className="col-span-2 lg:col-span-2 xl:col-span-4 col-start-2 lg:col-start-1 lg:px-16 xl:px-13 z-30">
          <img
            src="/images/studio/StudioLogo.svg"
            alt="Cultiv Studio Logo"
            className=" w-full bg-black xl:max-w-[274px]"
            width={274}
            height={64}
          />
        </div>

        {/**
         * Horizontal Line below studio logo
         */}
        <div className="absolute scale-y-50 col-start-2 xl:col-start-3 3xl:col-start-2 w-full md:w-[calc(100%+60px)] xl:w-[calc(100%+120px)] bottom-0 -z-20">
          <span className=" block h-0.5 bg-white w-full" />
        </div>
      </div>

      <StudioIcon className="lg:absolute xl:row-start-2 2xl:row-start-1 3xl:row-start-2 lg:left-96 xl:left-11 lg:top-48 xl:-top-10 2xl:top-32 3xl:-top-10 xl:row-span-2 xl:col-span-5 md:col-start-3 xl:col-start-9 2xl:col-start-8 3xl:col-start-9 w-full z-30" />

      <div className="px-6 xl:px-0 xl:row-start-2 xl:pt-32 h-full col-span-full lg:col-span-4 xl:col-span-5 lg:col-start-1 xl:col-start-1 w-full grid grid-cols-subgrid gap-y-8 md:gap-y-20 xl:gap-y-8 auto-rows-min">
        <p className="font-Light md:text-lg xl:text-lg 3xl:text-2xl pr-6 col-span-full">
          From brand, identity and UI/UX to full-stack software and marketing. We partner with you
          to turn ideas into immersive, impact driven experiences.
        </p>
        <ContactButton
          className="col-span-2 text-nowrap"
          bgHoverColor="hover:bg-cultiv-red"
          borderHoverColor="hover:border-cultiv-red"
          textHoverColor="hover:text-white"
          text="Let's Talk"
          path="/studio#contact"
        />
      </div>
      {/**
       * Horizontal Line above studio logo
       */}
      <div className="absolute scale-y-50 col-start-1 md:col-start-auto col-span-2 md:col-end-3 lg:col-end-4 xl:col-end-6 row-start-2 row-end-2 self-start xl:self-auto xl:row-start-1 xl:row-end-2 w-full xl:-bottom-0.5">
        <span className="block h-0.5 bg-white w-full self-start" />
      </div>

      <div className="absolute scale-y-50 xl:row-end-4 w-full -bottom-[2px]">
        <span className="block h-0.5 bg-white w-full self-start" />
      </div>

      {/* Vertical lines */}
      <div className="absolute left-[13.4%] xl:left-[100px] 2xl:left-[110px] scale-x-50 col-start-2 xl:col-start-5 top-0 row-start-2 xl:row-end-4 h-full">
        <span className="hidden xl:block w-0.5 bg-white h-full " />
      </div>
    </section>
  );
};

export default StudioHero;
